import { match } from 'ts-pattern';
import { BurnerBaseW24Variant, EvoAffinity25G, EvoAffinity30G, FuelType, LynxAsadoGriddgle, LynxKamadoGrill, LynxNapoliPizzaOven, LynxProfessionalCocktailStation, LynxProfessionalDoubleBurner, LynxProfessionalDoubleTapTowerKit, LynxProfessionalGrillVariant, LynxProfessionalGrillW30, LynxProfessionalGrillW36, LynxProfessionalGrillW42, LynxProfessionalGrillW54, LynxProfessionalOutdoorBeverageDispenserW24, LynxProfessionalOutdoorIceMachineDrainPump, LynxProfessionalOutdoorIceMachineW15, LynxProfessionalOutdoorRefrigeratorW24, LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24, LynxProfessionalPowerBurner, LynxProfessionalRefrigeratorFreezerComboW24, LynxProfessionalRefrigeratorW15, LynxProfessionalSingleBurner, LynxProfessionalSingleTapTowerKit, LynxProfessionalTwoDrawerRefrigeratorW24, LynxProfessionalWineCellarW15, LynxSedonaDoubleBurner, LynxSedonaGrillVariant, LynxSedonaGrillW30, LynxSedonaGrillW36, LynxSedonaGrillW42, LynxSedonaHoodW36, LynxSedonaHoodW42, LynxSedonaHoodW48, LynxSedonaSingleBurner, LynxSinkW18, LynxSinkW24, LynxSinkW30, LynxWarmingDrawer } from '../__generated/model/index.js';
import { NO_VARIANT } from '../implementations/common.js';
export const fuelTypeToSkuSuffix = (fuelType)=>{
    return match(fuelType).with(FuelType.NaturalGas, ()=>'-NG').with(FuelType.Propane, ()=>'-LP').otherwise(()=>{
        throw new Error(`Unsupported fuel type suffix: ${fuelType}`);
    });
};
const emptyThumbnailUrl = '';
export const applianceData = {
    /**
   * LYNX PROFESSIONAL GRILL
   */ [`${LynxProfessionalGrillW30.type}_${LynxProfessionalGrillVariant.AllTrident}`]: {
        name: 'Lynx Professional Grill - 30" All Trident Burners',
        sku: 'L30ATR',
        description: '30" Professional Built-In Grill With All Trident Infrared Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW30.type}_${LynxProfessionalGrillVariant.TridentAndRotisserie}`]: {
        name: 'Lynx Professional Grill - 30" 1 Trident Burner & Rotisserie',
        sku: 'L30TR',
        description: '30" Professional Built in Grill with 1 Trident Infrared Burner and 1 Ceramic Burner and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW30.type}_${LynxProfessionalGrillVariant.RotisserieOnly}`]: {
        name: 'Lynx Professional Grill - 30" with Rotisserie',
        sku: 'L30R-3',
        description: '30" Professional Built in Grill with All Ceramic Burners and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW36.type}_${LynxProfessionalGrillVariant.AllTrident}`]: {
        name: 'Lynx Professional Grill - 36" All Trident Burners',
        sku: 'L36ATR',
        description: '36" Professional Built-In Grill With All Trident Infrared Burners And Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW36.type}_${LynxProfessionalGrillVariant.TridentAndRotisserie}`]: {
        name: 'Lynx Professional Grill - 36" 1 Trident Burner & Rotisserie',
        sku: 'L36TR',
        description: '36" Professional Built in Grill with 1 Trident Infrared Burner and 2 Ceramic Burners and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW36.type}_${LynxProfessionalGrillVariant.RotisserieOnly}`]: {
        name: 'Lynx Professional Grill - 36" with Rotisserie',
        sku: 'L36R-3',
        description: '36" Professional Built in Grill with All Ceramic Burners and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW42.type}_${LynxProfessionalGrillVariant.AllTrident}`]: {
        name: 'Lynx Professional Grill - 42" All Trident Burners',
        sku: 'L42ATR',
        description: '42" Professional Built-In Grill With All Trident Infrared Burners And Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW42.type}_${LynxProfessionalGrillVariant.TridentAndRotisserie}`]: {
        name: 'Lynx Professional Grill - 42" 1 Trident Burner & Rotisserie',
        sku: 'L42TR',
        description: '42" Professional Built in Grill with 1 Trident Infrared Burner and 2 Ceramic Burners and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW42.type}_${LynxProfessionalGrillVariant.RotisserieOnly}`]: {
        name: 'Lynx Professional Grill - 42" with Rotisserie',
        sku: 'L42R-3',
        description: '42" Professional Built in Grill with All Ceramic Burners and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxProfessionalGrillW54.type}_${LynxProfessionalGrillVariant.TridentAndRotisserie}`]: {
        name: 'Lynx Professional Grill - 54" 1 Trident Burner & Rotisserie',
        sku: 'L54TR',
        description: '54" Professional Built in Grill with 1 Trident Infrared Burner and 3 Ceramic Burners and Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    /**
   * LYNX SEDONA GRILL
   */ [`${LynxSedonaGrillW30.type}_${LynxSedonaGrillVariant.ProSear_SsBurner1}`]: {
        name: 'Lynx Sedona Grill - 30" - 1 ProSear & 1 SS Burner',
        sku: 'L501PS',
        description: '30" Sedona Built-In Grill With 1 Prosear Infrared Burner And 1 Stainless Steel Burner',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW30.type}_${LynxSedonaGrillVariant.ProSear_SsBurner1_Rotisserie}`]: {
        name: 'Lynx Sedona Grill - 30" - 1 ProSear & 1 SS Burner & Rotisserie',
        sku: 'L501PSR',
        description: '30" Sedona Built-In Grill With Rotisserie, 1 Prosear Infrared Burner And 1 Stainless Steel Burner',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW36.type}_${LynxSedonaGrillVariant.SsBurner3}`]: {
        name: 'Lynx Sedona Grill - 36" - 3 SS Burners',
        sku: 'L601',
        description: '36" Sedona Built-In Grill With 3 Stainless Steel Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW36.type}_${LynxSedonaGrillVariant.ProSear_SsBurner2}`]: {
        name: 'Lynx Sedona Grill - 36" - 1 ProSear & 2 SS Burners',
        sku: 'L601PS',
        description: '36" Sedona Built-In Grill With 1 Prosear Infrared Burner And 2 Stainless Steel Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW36.type}_${LynxSedonaGrillVariant.SsBurner3_Rotisserie}`]: {
        name: 'Lynx Sedona Grill - 36" - 3 SS Burners & Rotisserie',
        sku: 'L601R',
        description: '36" Sedona Built-In Grill With 3 Stainless Steel Burners And Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW36.type}_${LynxSedonaGrillVariant.ProSear_SsBurner2_Rotisserie}`]: {
        name: 'Lynx Sedona Grill - 36" - 1 ProSear, 2 SS Burners, & Rotisserie',
        sku: 'L601PSR',
        description: '36" Sedona Built-In Grill With Rotisserie, 1 Prosear Infrared Burner And 2 Stainless Steel Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW42.type}_${LynxSedonaGrillVariant.SsBurner3}`]: {
        name: 'Lynx Sedona Grill - 42" - 3 SS Burners',
        sku: 'L701',
        description: '42" Sedona Built-In Grill With 3 Stainless Steel Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW42.type}_${LynxSedonaGrillVariant.ProSear_SsBurner2}`]: {
        name: 'Lynx Sedona Grill - 42" - 1 ProSear & 2 SS Burners',
        sku: 'L701PS',
        description: '42" Sedona Built-In Grill With 1 Prosear Infrared Burner And 2 Stainless Steel Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW42.type}_${LynxSedonaGrillVariant.SsBurner3_Rotisserie}`]: {
        name: 'Lynx Sedona Grill - 42" - 3 SS Burners & Rotisserie',
        sku: 'L701R',
        description: '42" Sedona Built-In Grill With 3 Stainless Steel Burners And Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    [`${LynxSedonaGrillW42.type}_${LynxSedonaGrillVariant.ProSear_SsBurner2_Rotisserie}`]: {
        name: 'Lynx Sedona Grill - 42" - 1 ProSear, 2 SS Burners, & Rotisserie',
        sku: 'L701PSR',
        description: '42" Sedona Built-In Grill With Rotisserie, 1 Prosear Infrared Burner And 2 Stainless Steel Burners',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    /**
   * Lynx Sink
   */ [`${LynxSinkW18.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Sink - 18"',
        sku: 'LSK18',
        description: 'Lynx Professional Sink - 18"',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxSinkW24.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Sink - 24"',
        sku: 'LSK24',
        description: 'Lynx Professional Sink - 24"',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxSinkW30.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Sink - 30"',
        sku: 'LSK30',
        description: 'Lynx Professional Sink - 30"',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * Lynx Professional Cocktail Station
   */ [`${LynxProfessionalCocktailStation.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Cocktail Station',
        sku: 'LCS30',
        description: 'Lynx Professional Cocktail Station',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * EVO Affinity
   */ [`${EvoAffinity25G.type}_${NO_VARIANT}`]: {
        name: 'EVO Affinity 25G',
        sku: '10-0095',
        description: 'EVO Affinity 25G',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${EvoAffinity30G.type}_${NO_VARIANT}`]: {
        name: 'EVO Affinity 30G',
        sku: '10-0055',
        description: 'EVO Affinity 30G',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * Lynx Asado
   */ [`${LynxAsadoGriddgle.type}_${NO_VARIANT}`]: {
        name: 'Lynx Asado - Flat Top Griddle',
        sku: 'L30AG',
        description: '30" Cooktop Asado By Lynx Built-In',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    },
    /**
   * Lynx Burners
   */ [`${LynxProfessionalSingleBurner.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Single Side Burner',
        sku: 'LSB1-3',
        description: 'Professional Single Side Burner for Built-In Grills',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0.5 * 25.4,
        offsetZ: 1 * 25.4,
        powderCoatingUpcharge: {
            retail: 250,
            dealer: 169
        }
    },
    [`${LynxProfessionalDoubleBurner.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Double Side Burner',
        sku: 'LSB2-2',
        description: 'Professional Double Side Burner for Built-In Grills',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0.5 * 25.4,
        offsetZ: 1 * 25.4,
        powderCoatingUpcharge: {
            retail: 250,
            dealer: 169
        }
    },
    [`${LynxProfessionalPowerBurner.type}_${NO_VARIANT}`]: {
        name: 'Lynx Professional Power Burner',
        sku: 'LPB',
        description: 'Professional Power Burner',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetYFn: (s)=>s.$cabinet.variant === BurnerBaseW24Variant.Lowered ? -225 : 0,
        offsetZ: 1 * 25.4,
        powderCoatingUpcharge: {
            retail: 250,
            dealer: 169
        }
    },
    /**
   * Lynx Kamado Grill
   */ [`${LynxKamadoGrill.type}_${NO_VARIANT}`]: {
        name: 'Lynx Kamado Grill',
        sku: 'LCGR',
        description: 'Lynx Kamado Grill - Ceramic Charcoal Grill with Rotisserie',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        // Middle of the Kamado grill is aligned with cabinet doors.
        // Push it back to sit inside the cabinet.
        offsetZ: -27.25 * 25.4 * (1 / 3),
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * Lynx Napoli Pizza Oven
   */ [`${LynxNapoliPizzaOven.type}_${NO_VARIANT}`]: {
        name: 'Napoli Pizza Oven',
        sku: 'LPZA',
        description: 'Lynx Napoli Pizza Oven - Built-In Wood-Fired Pizza Oven',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        height: 29 * 25.4,
        offsetX: 0,
        offsetY: 1.5 * 25.4,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * Lynx Sedona Burners
   */ [`${LynxSedonaSingleBurner.type}_${NO_VARIANT}`]: {
        name: 'Sedona Single Side Burner',
        sku: 'LSB501',
        description: 'Sedona Single Side Burner',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0.5 * 25.4,
        offsetZ: 1 * 25.4,
        powderCoatingUpcharge: {
            retail: 250,
            dealer: 169
        }
    },
    [`${LynxSedonaDoubleBurner.type}_${NO_VARIANT}`]: {
        name: 'Sedona Double Side Burner',
        sku: 'LSB502',
        description: 'Sedona Double Side Burner',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [
            FuelType.NaturalGas,
            FuelType.Propane
        ],
        offsetX: 0,
        offsetY: 0.5 * 25.4,
        offsetZ: 1 * 25.4,
        powderCoatingUpcharge: {
            retail: 250,
            dealer: 169
        }
    },
    /**
   * Lynx Sedona Hoods
   */ [`${LynxSedonaHoodW36.type}_${NO_VARIANT}`]: {
        name: 'Lynx Sedona Vent Hood - 36"',
        sku: 'SVH36',
        description: '36" Sedona Vent Hood',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxSedonaHoodW42.type}_${NO_VARIANT}`]: {
        name: 'Lynx Sedona Vent Hood - 42"',
        sku: 'SVH42',
        description: '42" Sedona Vent Hood',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxSedonaHoodW48.type}_${NO_VARIANT}`]: {
        name: 'Lynx Sedona Vent Hood - 48"',
        sku: 'SVH48',
        description: '48" Sedona Vent Hood',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * Lynx Refrigeration
   */ [`${LynxProfessionalOutdoorBeverageDispenserW24.type}_${NO_VARIANT}`]: {
        name: '24" Professional Outdoor Beverage Dispenser',
        sku: 'LN24BF1',
        description: '24" Professional Outdoor Beverage Dispenser',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.8165 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalRefrigeratorFreezerComboW24.type}_${NO_VARIANT}`]: {
        name: '24" Professional Refrigerator Freezer Combo',
        sku: 'LN24REFC',
        description: '24" Professional Refrigerator Freezer Combo',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.8165 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalOutdoorRefrigeratorW24.type}_${NO_VARIANT}`]: {
        name: '24" Professional Outdoor Refrigerator',
        sku: 'LN24REF',
        description: '24" Professional Outdoor Refrigerator',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.8165 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24.type}_${NO_VARIANT}`]: {
        name: '24" Professional Outdoor Refrigerator with Glass Door',
        sku: 'LN24REFG',
        description: '24" Professional Outdoor Refrigerator with Glass Door',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.8165 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalRefrigeratorW15.type}_${NO_VARIANT}`]: {
        name: '15" Professional Refrigerator',
        sku: 'LN15REF',
        description: '15" Professional Refrigerator',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.93 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalWineCellarW15.type}_${NO_VARIANT}`]: {
        name: '15" Professional Wine Cellar',
        sku: 'LN15WINE',
        description: '15" Professional Wine Cellar',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.93 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalTwoDrawerRefrigeratorW24.type}_${NO_VARIANT}`]: {
        name: '24" Professional Two Drawer Refrigerator',
        sku: 'LN24DWR',
        description: '24" Professional Two Drawer Refrigerator',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.7765 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalOutdoorIceMachineW15.type}_${NO_VARIANT}`]: {
        name: '15" Professional Outdoor Ice Machine',
        sku: 'LN15ICE',
        description: '15" Professional Outdoor Ice Machine',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 10,
        offsetZ: 0,
        height: 33.807 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalOutdoorIceMachineDrainPump.type}_${NO_VARIANT}`]: {
        name: 'Drain Pump for 15" Outdoor Ice Machine',
        sku: 'LN15ICE-DP',
        description: 'Drain Pump for 15" Outdoor Ice Machine',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        height: 0,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalSingleTapTowerKit.type}_${NO_VARIANT}`]: {
        name: 'Professional Single Tap Tower Kit',
        sku: 'L24TWS',
        description: 'Professional Single Tap Tower Kit',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        height: 23.6326 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    [`${LynxProfessionalDoubleTapTowerKit.type}_${NO_VARIANT}`]: {
        name: 'Professional Double Tap Tower Kit',
        sku: 'L24TWD',
        description: 'Professional Double Tap Tower Kit',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        height: 23.6326 * 25.4,
        powderCoatingUpcharge: {
            retail: 0,
            dealer: 0
        }
    },
    /**
   * Warming Drawer
   */ [`${LynxWarmingDrawer.type}_${NO_VARIANT}`]: {
        name: '30" Professional Outdoor Warming Drawer',
        sku: 'L30WD',
        description: '30" Professional Outdoor Warming Drawer',
        thumbnailUrl: emptyThumbnailUrl,
        fuelTypes: [],
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        height: 0,
        powderCoatingUpcharge: {
            retail: 400,
            dealer: 270
        }
    }
};
export const applianceDataBySku = Object.entries(applianceData).reduce((acc, [key, item])=>{
    acc[item.sku] = {
        ...item,
        key
    };
    return acc;
}, {});

//# sourceMappingURL=appliances.js.map